var map = {
	"./KROL/inventory.json": 4134,
	"./SWC/inventory.json": 4135
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4133;


//////////////////
// WEBPACK FOOTER
// ./data/sheets ^\.\/.*\/inventory\.json$
// module id = 4133
// module chunks = 0